module.exports = __webpack_public_path__ + "static/media/show1.4dacc862.png";